import type { StyleLayer } from './utils/types'

export const layers_bikelane_presence: StyleLayer[] = [
  {
    id: 'hitarea-bikelane-presence',
    type: 'line',
    filter: ['any', ['has', 'bikelane_left'], ['has', 'bikelane_right'], ['has', 'bikelane_self']],
    layout: {
      'line-cap': 'round',
    },
    paint: {
      'line-color': '#d814ff',
      'line-opacity': 0,
      'line-width': ['interpolate', ['linear'], ['zoom'], 8, 1, 16, 14],
    },
  },
  {
    id: 'bikelane_right',
    type: 'line',
    filter: ['has', 'bikelane_right'],
    paint: {
      'line-color': [
        'case',
        ['match', ['get', 'bikelane_right'], ['missing'], true, false],
        '#fa80f4',
        ['match', ['get', 'bikelane_right'], ['not_expected'], true, false],
        'rgba(234, 200, 210, 0.68)',
        ['match', ['get', 'bikelane_right'], ['assumed_no'], true, false],
        'rgba(251, 172, 196, 0.69)',
        ['match', ['get', 'bikelane_right'], ['data_no'], true, false],
        'rgba(108, 124, 147, 0.67)',
        ['has', 'bikelane_right'],
        'rgba(142, 177, 240, 0.7)',
        'rgba(0, 0, 0, 0.7)',
      ],
      'line-offset': ['step', ['zoom'], 1, 14, 4, 16, 8],
      'line-opacity': [
        'interpolate',
        ['linear'],
        ['zoom'],
        11,
        ['match', ['get', 'bikelane_right'], ['missing'], 0.7, 0],
        12,
        0.7,
      ],
      'line-width': [
        'interpolate',
        ['linear'],
        ['zoom'],
        8,
        1,
        16,
        ['match', ['get', 'bikelane_right'], ['missing'], 8, 4],
      ],
    },
  },
  {
    id: 'bikelane_self',
    type: 'line',
    filter: ['has', 'bikelane_self'],
    paint: {
      'line-color': [
        'case',
        ['match', ['get', 'bikelane_self'], ['missing'], true, false],
        '#fa80f4',
        ['match', ['get', 'bikelane_self'], ['not_expected'], true, false],
        'rgba(234, 200, 210, 0.68)',
        ['match', ['get', 'bikelane_self'], ['assumed_no'], true, false],
        'rgba(251, 172, 196, 0.65)',
        ['match', ['get', 'bikelane_self'], ['data_no'], true, false],
        'rgba(108, 124, 147, 0.67)',
        ['has', 'bikelane_self'],
        'rgba(142, 177, 240, 0.7)',
        'rgba(0, 0, 0, 0.7)',
      ],
      'line-opacity': [
        'interpolate',
        ['linear'],
        ['zoom'],
        11,
        ['match', ['get', 'bikelane_self'], ['missing'], 0.7, 0],
        12,
        0.7,
      ],
      'line-width': [
        'interpolate',
        ['linear'],
        ['zoom'],
        8,
        1,
        16,
        ['match', ['get', 'bikelane_self'], ['missing'], 8, 4],
      ],
    },
  },
  {
    id: 'bikelane_left',
    type: 'line',
    filter: ['has', 'bikelane_left'],
    paint: {
      'line-color': [
        'case',
        ['match', ['get', 'bikelane_left'], ['missing'], true, false],
        '#fa80f4',
        ['match', ['get', 'bikelane_left'], ['not_expected'], true, false],
        'rgba(234, 200, 210, 0.68)',
        ['match', ['get', 'bikelane_left'], ['assumed_no'], true, false],
        'rgba(251, 172, 196, 0.68)',
        ['match', ['get', 'bikelane_left'], ['data_no'], true, false],
        'rgba(108, 124, 147, 0.67)',
        ['has', 'bikelane_left'],
        'rgba(142, 177, 240, 0.7)',
        'rgba(0, 0, 0, 0.7)',
      ],
      'line-offset': ['step', ['zoom'], -1, 14, -4, 16, -8],
      'line-opacity': [
        'interpolate',
        ['linear'],
        ['zoom'],
        11,
        ['match', ['get', 'bikelane_left'], ['missing'], 0.7, 0],
        12,
        0.7,
      ],
      'line-width': [
        'interpolate',
        ['linear'],
        ['zoom'],
        8,
        1,
        16,
        ['match', ['get', 'bikelane_left'], ['missing'], 8, 4],
      ],
    },
  },
  {
    id: 'left-right-indication-arrow',
    type: 'symbol',
    layout: {
      'icon-allow-overlap': true,
      'icon-image': 'chevron-double-right',
      'icon-padding': 0,
      'icon-size': [
        'case',
        ['match', ['get', 'bikelane_self'], ['missing'], true, false],
        0.8,
        [
          'any',
          ['match', ['get', 'bikelane_left'], ['missing'], true, false],
          ['match', ['get', 'bikelane_right'], ['missing'], true, false],
        ],
        0.8,
        0.5,
      ],
      'symbol-avoid-edges': true,
      'symbol-placement': 'line',
      'symbol-spacing': 100,
    },
    paint: {
      'icon-opacity': [
        'interpolate',
        ['linear'],
        ['zoom'],
        0,
        0,
        13,
        0,
        14,
        [
          'case',
          ['match', ['get', 'bikelane_self'], ['missing'], true, false],
          1,
          [
            'any',
            ['match', ['get', 'bikelane_left'], ['missing'], true, false],
            ['match', ['get', 'bikelane_right'], ['missing'], true, false],
          ],
          1,
          0.4,
        ],
      ],
    },
  },
]
